import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import {BookizonAppManager} from "../../../../../index";
import {UploadedFilePreview} from "../../../../../components/FileManager/UploadedFilePreview";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";

export default class TimeoffRequestsFilesTab extends React.Component {
    constructor(props) {
        super(props);
        const defaultStaffId = this.getDefaultStaffId(props.staffList);
        this.state = {
            selectedStaffId: defaultStaffId,
            files: [],
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        this.fetchFiles();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedStaffId !== this.state.selectedStaffId) {
            this.fetchFiles();
        }

        if (prevProps.staffList !== this.props.staffList && !this.state.selectedStaffId) {
            const defaultStaffId = this.getDefaultStaffId(this.props.staffList);
            if (defaultStaffId) {
                this.setState({selectedStaffId: defaultStaffId});
            }
        }
    }

    getDefaultStaffId = staffList => {
        if (!staffList || !staffList.length) return null;
        return staffList[0].id_dipendente || null;
    }

    handleStaffChange = e => {
        const selectedStaffId = parseInt(e.target.value, 10) || null;
        this.setState({selectedStaffId: selectedStaffId});
    }

    fetchFiles = _ => {
        if (!this.state.selectedStaffId) {
            this.setState({files: [], loading: false, error: null});
            return;
        }

        this.setState({loading: true, error: null});
        ModuloHRAPI.Files.getFiles(this.state.selectedStaffId)
            .then(files => {
                this.setState({files: files || [], loading: false});
            })
            .catch(error => {
                this.setState({files: [], loading: false, error: error || "Non e' stato possibile caricare i file"});
            });
    }

    getTagsFromFile = file => {
        const tagsCsv = file?.tags_csv || "";
        return tagsCsv
            .split(",")
            .map(tag => tag.trim())
            .filter(tag => tag.length);
    }

    handleOpenFile = file => _ => {
        if (file && file.url) {
            BookizonAppManager.openInAppBrowser(file.url);
        }
    }

    renderTagBadge = (tag, index) => {
        return (
            <span key={`${tag}-${index}`} className={"badge badge-secondary mr-1"}>
                {tag}
            </span>
        );
    }

    renderFileItem = (file, index) => {
        const tags = this.getTagsFromFile(file);
        return (
            <button
                key={file.id_file || index}
                type={"button"}
                className={"list-group-item list-group-item-action"}
                onClick={this.handleOpenFile(file)}
            >
                <div className={"d-flex align-items-center justify-content-between"}>
                    <div className={"d-flex align-items-center"}>
                        <UploadedFilePreview file={file}/>
                        <div>
                            <div className={"font-weight-bold"}>{file.filename || "File"}</div>
                            {
                                file.note &&
                                <div className={"text-muted small"}>
                                    {file.note}
                                </div>
                            }
                        </div>
                    </div>
                    <FaSolidIcon name={"chevron-right"} className={"text-muted"}/>
                </div>
                {
                    tags.length > 0 &&
                    <div className={"mt-2"}>
                        {tags.map(this.renderTagBadge)}
                    </div>
                }
            </button>
        );
    }

    renderContent = _ => {
        if (!this.state.selectedStaffId) {
            return (
                <div className={"text-center text-muted py-4"}>
                    Nessun collaboratore disponibile.
                </div>
            );
        }

        if (this.state.loading) {
            return (
                <div className={"text-center text-muted py-4"}>
                    Caricamento file...
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className={"text-center text-danger py-4"}>
                    {this.state.error}
                </div>
            );
        }

        if (!this.state.files.length) {
            return (
                <div className={"text-center text-muted py-4"}>
                    Non ci sono file disponibili.
                </div>
            );
        }

        return (
            <div className={"list-group"}>
                {this.state.files.map(this.renderFileItem)}
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <div className={"container pt-3 pb-4"}>
                    <div className={"form-group"}>
                        <label>Collaboratore</label>
                        <select
                            className={"form-control"}
                            value={this.state.selectedStaffId || ""}
                            onChange={this.handleStaffChange}
                        >
                            {
                                (this.props.staffList || []).map(staff => {
                                    const label = staff.negozio?.nome ? `${staff.nome} - ${staff.negozio.nome}` : staff.nome;
                                    return (
                                        <option key={staff.id_dipendente} value={staff.id_dipendente}>
                                            {label}
                                        </option>
                                    );
                                })
                            }
                        </select>
                    </div>
                    {this.renderContent()}
                </div>
            </Fragment>
        );
    }
}

TimeoffRequestsFilesTab.propTypes = {
    staffList: PropTypes.array
};
